/**
* @Author nanfeng
* @CreatTime 2020-03-31 15:48
* @Des form 表单加工厂
*/

/** 
 * @params FormField: 表单field, FormData: 表单初始化数据
 * @returns rules: 表单验证规则， model: 表单数据, field: 表单field
 */
export function getFormData(FormField = [], FormData = {}, settingData={}) {
    let rules = {}, model = {}, field = []
    if (FormField.length) { 
        field = FormField.map((item, index, arr) => {
            let  arrItem= []
            if (item.required) {
                let obj = {}
                obj.required = true
                if (item.form_type == 'text' || item.form_type == 'number' || item.form_type == 'textarea' || item.form_type == 'mobile' || item.form_type == 'email' || item.form_type == 'password') {
                    obj.message = "请输入" + item.label
                    obj.trigger = "blur"
                } else if (item.form_type == 'select' || item.form_type == 'radio' || item.form_type == 'checkbox') {
                    obj.message = "请选择" + item.label
                    obj.trigger = "change"
                }
                arrItem.push(obj)
            }
            rules[item.field] = arrItem
            if (item.form_type == 'select') {
                model[item.field] = parseFloat(FormData[item.field]) || item.default_value;
                if (settingData[item.field]) {
                    item['setting'] = settingData[item.field]
                }
            } else {
                model[item.field] = FormData[item.field] || item.default_value;
            }
            return item
        })
    }
    
    return {
        rules,
        model,
        field
    }
}

/** 
 * 转化为element ui select 可用数据源
 * @params data: 数据源, field_label: label转化字段, field_value: value转化字段, 
 * @returns rules: 转化结果
 */
export function getSelectData(data, field_label, field_value) {
    let result = []
    if (data&&data.length) {
        result = data.map((item)=>{
            let obj = {}
            obj.label = item[field_label]
            obj.value = item[field_value]
            return obj
        })
    }
    return result
}